import React from 'react';
import { Avatar } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import { resolveUrl } from '../utils/url';

interface Props {
  content: string;
  agentInfo?: { name?: string; avatar?: string } | null;
  agentKey: string;
  renderAIContent: (content: string) => React.ReactNode;
}

const UzyToolSummary: React.FC<Props> = ({ content, agentInfo, agentKey, renderAIContent }) => (
  <div className="chat-message chat-message-ai">
    <Avatar size={32} className="chat-agent-bubble-avatar" src={resolveUrl(agentInfo?.avatar)}>
      {agentInfo?.name?.charAt(0)?.toUpperCase() || <RobotOutlined />}
    </Avatar>
    <div className="chat-bubble-wrapper">
      <div className="chat-agent-bubble-name">{agentInfo?.name || agentKey}</div>
      <div className="chat-bubble chat-bubble-agent">
        <div className="chat-bubble-content chat-markdown">{renderAIContent(content)}</div>
      </div>
    </div>
  </div>
);

export default UzyToolSummary;
